import DynamicExperianFields from "../DynamicExperianFields"
import React, { useEffect, useState } from "react"
import ModalComponent from "../../../../components/Modal/Modal"
import { validateForm } from "./helper"
import { updateDebtByUserIdAndDebtId } from "../../../../features/creditReports/creditReports"
import { showSnackBar } from "../../../../components/Snackbar/Snackbar"
import { useMyContextLoading } from "../../../../components/LoadingContextProvider/LoadingContextProvider"
import { useDispatch } from "react-redux"
import { now } from "../../../../utils/date"

const UpdateCreditReportFields = ({
                                    creditLine,
                                    initialFieldSet,
                                    open,
                                    setOpen,
                                    setTriggerFetchDebts,
                                  }) => {
  const { triggerLoading } = useMyContextLoading()
  const dispatch = useDispatch()

  const [errors, setErrors] = useState([])
  const [updatedDebt, setUpdatedDebt] = useState([])


  const updateDebt = async () => {
    triggerLoading(true)
    const {
      accountType, accountNumber, openedDate, reportedDate, closedDate,
      lastPaymentDate, accountStatus, paymentStatus, creditorName, balanceAmount,
      pastDueAmount, creditLimit, isOpenAccount,
    } = updatedDebt[0]

    const debtFields = {
      accountType: accountType || "",
      accountNumber: accountNumber || "",
      openedDate: openedDate || now(),
      reportedDate: reportedDate || now(),
      closedDate: closedDate || now(),
      lastPaymentDate: lastPaymentDate || now(),
      accountStatus: accountStatus || "",
      paymentStatus: paymentStatus || "",
      creditorName: creditorName || "",
      balanceAmount: balanceAmount || "",
      pastDueAmount: pastDueAmount || "",
      creditLimit: creditLimit || "",
      isOpenAccount: typeof isOpenAccount === 'boolean' ? isOpenAccount : "",
    }

    const response = await dispatch(updateDebtByUserIdAndDebtId({
      debtId: creditLine?._id,
      userId: creditLine?.user,
      data: debtFields
    }))

    if (response?.payload?.data) {
      showSnackBar("success", "The debt has been updated")
      setTriggerFetchDebts(prev => !prev)
    }
    triggerLoading(false)
  }


  useEffect(() => {
    validateForm({ creditLine, setErrors })
    setUpdatedDebt([creditLine])
  }, [creditLine])

  return (
    <div>
      <ModalComponent
        modalButtonTitle="Update"
        buttonType="outlined"
        buttonTitleStyle="flex justify-center"
        title={"Update Debts"}
        functionButton={updateDebt}
        customScroll={true}
        disabled={
          errors?.some((err) => Object.keys(err).length > 0)
        }
        disableBtn={false}
        customOpenModal={open}
        onClose={setOpen}
      >
        <DynamicExperianFields
          fields={updatedDebt}
          setFields={setUpdatedDebt}
          errors={errors}
          setErrors={setErrors}
          initialFieldSet={initialFieldSet}
          isUpdate={true}
        />
      </ModalComponent>
    </div>
  )
}

export default UpdateCreditReportFields